<template>
	<div v-bind:class="contraer ? 'col-md-9' : 'col-md-10'">
		<div class="row panel-main">
			<div class="col-12">
				<div class="row">
					<div class="col-12">
						<div class="boton-cerrar"><i class="fas fa-times fa-fw fa-2x" @click="cerrarPanel" /></div>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<detalle v-if="accion == 'detalle'" :info="info" :key="'detalle_' + info + '_' + periodo"></detalle>
						<carga-15-dias v-if="accion == 'carga15'" :contraer="contraer"></carga-15-dias>	
						<carga-30-dias v-if="accion == 'carga30'" d:contraer="contraer"></carga-30-dias>	
						<emitidos v-if="accion == 'emitidos'" d:contraer="contraer" :key="'emitidos_' + periodo"></emitidos>	
						<diferencias v-if="accion == 'diferencias'" d:contraer="contraer" :key="'diferencias_' + periodo"></diferencias>	
						<masivo v-if="accion == 'masivo'" :info="info" :key="'masivo_' + info"></masivo>
						<con-iva v-if="accion == 'coniva'" :info="info" :key="'coniva_' + info" :on-resumen="onResumen"></con-iva>
						<uno-x-uno v-if="accion == 'unoxuno'" :info="info" :key="'unoxuno_' + info + '_' + periodo"></uno-x-uno>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import Detalle from "./detalle.vue"
	import Carga15Dias from "./Carga15Dias/main.vue"
	import Carga30Dias from "./Carga30Dias/main.vue"
	import Emitidos from "./Emitidos/main.vue"
	import Diferencias from "./Diferencias/main.vue"
	import Masivo from "./Masivo/main.vue"
	import ConIva from "./ConIva/main.vue"
	import UnoXUno from "./UnoXUno/main.vue"


	export default {
		name: "Panel",
		components: { Detalle, Carga15Dias, Carga30Dias, Emitidos, Diferencias, Masivo, ConIva, UnoXUno },
		props: {
			accion: String,
			info: String,
			contraer: Boolean,
			onCerrar: Function,
		},
		data() {
			return {
				periodo: "",
			}
		},
		created() {

			this.periodo = this.$periodo
		},
		mounted: function() {

			const that = this

			window.event.$on("evento-cambio-periodo", function(periodo) {

				that.periodo = periodo
			})
		},
		methods: {

            cerrarPanel() {

				// Llamamos a la funcion callback asociada a la accion de cerrar el panel
				if (this.onCerrar)
					this.onCerrar()
            },

			onResumen() {

				this.cerrarPanel()
			},
		}
	}

</script>
<style scoped>

	.panel-main {
		padding: 10px 0 10px 0;
		margin-top: 10px;
		margin-right: 0px;
		overflow: auto;
		background-color: white;
		border-radius: 5px;
		min-height: 800px;
	}

	.boton-cerrar {
		width: 100%;
		text-align: right;
	}

	.boton-cerrar i:hover {
		cursor: pointer;
	}

</style>
